module.exports = __webpack_public_path__ + "static/media/download.c6dc8463.svg";